import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJImagePreviewModal from './FJImagePreviewModal';
import FJActionModal from '../../../redux/action/FJActionModal';
import FJModal from '../FJModal';

const FJImagePreviewModalContainer = () => {
    const dispatch = useDispatch();

    // 从 Redux store 获取状态
    const imagePreviewModalData = useSelector(state => state.modals.imagePreviewModalData || {});
    const { display, imageList, currentIndex, showDeleteButton, showDownloadButton, onDelete, onDownload } =
        imagePreviewModalData;

    // 关闭模态框
    const handleClose = useCallback(() => {
        dispatch(FJActionModal.hideImagePreviewModalAction());
    }, [dispatch]);

    return (
        <FJModal visible={display}>
            <FJImagePreviewModal
                active={display}
                onClose={handleClose}
                imageList={imageList}
                currentIndex={currentIndex}
                showDeleteButton={showDeleteButton}
                showDownloadButton={showDownloadButton}
                onDelete={onDelete}
                onDownload={onDownload}
            />
        </FJModal>
    );
};

export default FJImagePreviewModalContainer;
